var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.customPage
    ? _c("custom-page", { attrs: { slug: _vm.customPage.slug } })
    : _c("div", { staticClass: "welcome-page" }, [
        _c("header", { staticClass: "welcome-heading" }, [
          _c("div", [
            _c("span", { staticClass: "client-eyebrow" }, [
              _vm._v(_vm._s(_vm.clientName))
            ]),
            _c("h1", [_vm._v(_vm._s(_vm.$t("nav.home")))])
          ]),
          _c(
            "div",
            {
              staticClass: "attention-summary",
              attrs: {
                "aria-label": _vm.$t("nav.notifications"),
                "aria-live": "polite"
              }
            },
            [
              _c("portal-icon", { attrs: { name: "bell", size: 19 } }),
              _c("strong", [_vm._v(_vm._s(_vm.actionCount))]),
              _c("span", [_vm._v(_vm._s(_vm.$t("nav.notifications")))])
            ],
            1
          )
        ]),
        _vm.safeWelcomeGreeting
          ? _c(
              "section",
              {
                staticClass: "welcome-message",
                class: { "has-background": _vm.backgroundImage },
                style: _vm.backgroundStyle
              },
              [
                _c("div", {
                  staticClass: "welcome-message-content",
                  domProps: { innerHTML: _vm._s(_vm.safeWelcomeGreeting) }
                })
              ]
            )
          : _vm._e(),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass: "dashboard-loading",
                attrs: {
                  role: "status",
                  "aria-label": _vm.$t("nav.notifications")
                }
              },
              _vm._l(4, function(index) {
                return _c("div", { key: index, staticClass: "loading-card" }, [
                  _c("span"),
                  _c("span"),
                  _c("span")
                ])
              }),
              0
            )
          : _vm.loadError
          ? _c(
              "section",
              { staticClass: "dashboard-state", attrs: { role: "alert" } },
              [
                _c("portal-icon", {
                  attrs: { name: "alert-circle", size: 28 }
                }),
                _c("p", [_vm._v(_vm._s(_vm.$t("error.connecting-account")))]),
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("error.connecting-account")
                    },
                    on: { click: _vm.getActionItems }
                  },
                  [_c("portal-icon", { attrs: { name: "refresh", size: 20 } })],
                  1
                )
              ],
              1
            )
          : _vm.actionCount
          ? _c(
              "section",
              {
                staticClass: "action-dashboard",
                attrs: { "aria-label": _vm.$t("nav.notifications") }
              },
              [
                _vm.features.projectsEnabled
                  ? _c("deliverables", {
                      attrs: {
                        deliverables: _vm.actionItems.assignedTasks || [],
                        "task-mode": ""
                      },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e(),
                _vm.features.ticketsEnabled
                  ? _c("tickets", {
                      attrs: { tickets: _vm.actionItems.openTickets || [] }
                    })
                  : _vm._e(),
                _vm.features.projectsEnabled
                  ? _c("deliverables", {
                      attrs: {
                        deliverables: _vm.actionItems.deliverables || []
                      },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e(),
                _vm.features.invoicesEnabled
                  ? _c("invoices", {
                      attrs: { invoices: _vm.actionItems.invoices || [] },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e(),
                _vm.features.formsEnabled
                  ? _c("forms", {
                      attrs: { forms: _vm.actionItems.forms || [] },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e(),
                _vm.features.proposalsEnabled
                  ? _c("proposals", {
                      attrs: {
                        proposals: _vm.actionItems.proposals || [],
                        agreements: _vm.actionItems.agreements || []
                      },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e(),
                _vm.features.meetingsEnabled
                  ? _c("meetings", {
                      attrs: { meetings: _vm.actionItems.meetings || [] },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e(),
                _vm.features.invoicesEnabled
                  ? _c("subscription-requests", {
                      attrs: {
                        "subscription-requests":
                          _vm.actionItems.subscriptionRequests || []
                      },
                      on: { refresh: _vm.getActionItems }
                    })
                  : _vm._e()
              ],
              1
            )
          : !_vm.paymentPlans.length
          ? _c("section", { staticClass: "dashboard-state" }, [
              _c(
                "span",
                { staticClass: "empty-state-icon" },
                [_c("portal-icon", { attrs: { name: "check", size: 28 } })],
                1
              ),
              _c("strong", [_vm._v("0 " + _vm._s(_vm.$t("nav.notifications")))])
            ])
          : _vm._e(),
        !_vm.loading && !_vm.loadError && _vm.paymentPlans.length
          ? _c(
              "section",
              {
                staticClass: "upcoming-dashboard",
                attrs: {
                  "aria-label": _vm.$t("payment-plans.upcoming-payments")
                }
              },
              [_c("payment-plans", { attrs: { plans: _vm.paymentPlans } })],
              1
            )
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }